module.exports = __webpack_public_path__ + "media/images/icons/ic-textfield-help-small-86f91a2ea94419e8a570c4a2e6e62d95.svg";